export const FETCH_CHEMISTUSERDETAILS_INIT_ACTION =
  "FETCH_CHEMISTUSERDETAILS_INIT_ACTION";
export const FETCH_CHEMISTUSERDETAILS_SUCCESS_ACTION =
  FETCH_CHEMISTUSERDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTUSERDETAILS_FAIL_ACTION =
  FETCH_CHEMISTUSERDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_CHEMISTINACTIVE_INIT_ACTION =
  "FETCH_CHEMISTINACTIVE_INIT_ACTION";
export const FETCH_CHEMISTINACTIVE_SUCCESS_ACTION =
  FETCH_CHEMISTINACTIVE_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTINACTIVE_FAIL_ACTION =
  FETCH_CHEMISTINACTIVE_INIT_ACTION + "_ERROR";

export const FETCH_CHEMISTOPERATION_INIT_ACTION =
  "FETCH_CHEMISTOPERATION_INIT_ACTION";
export const FETCH_CHEMISTOPERATION_SUCCESS_ACTION =
  FETCH_CHEMISTOPERATION_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTOPERATION_FAIL_ACTION =
  FETCH_CHEMISTOPERATION_INIT_ACTION + "_ERROR";

export const FETCH_CHEMISTDETAILSVIEW_INIT_ACTION =
  "FETCH_CHEMISTDETAILSVIEW_INIT_ACTION";
export const FETCH_CHEMISTDETAILSVIEW_SUCCESS_ACTION =
  FETCH_CHEMISTDETAILSVIEW_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTDETAILSVIEW_FAIL_ACTION =
  FETCH_CHEMISTDETAILSVIEW_INIT_ACTION + "_ERROR";

export const FETCH_OFFERS_INIT = "FETCH_OFFERS_INIT";
export const FETCH_OFFERS_SUCCESS = FETCH_OFFERS_INIT + "_SUCCESS";
export const FETCH_OFFERS_FAIL = FETCH_OFFERS_INIT + "_FAIL";

export function ChemistUser(value) {
  return {
    type: FETCH_CHEMISTUSERDETAILS_INIT_ACTION,
    value: value,
  };
}

export function ChemistDetailsview(value) {
  return {
    type: FETCH_CHEMISTDETAILSVIEW_INIT_ACTION,
    value: value,
  };
}

export function ChemistUserSlectedPage(value) {
  return {
    type: FETCH_CHEMISTUSERDETAILS_INIT_ACTION,
    value: value,
  };
}

export function ChemistInActive(value) {
  return {
    type: FETCH_CHEMISTINACTIVE_INIT_ACTION,
    value: value,
  };
}

export function ChemistOprMode(value) {
  return {
    type: FETCH_CHEMISTOPERATION_INIT_ACTION,
    value: value,
  };
}

export function fetchchemistOfferDtls(value) {
  return {
    type: FETCH_OFFERS_INIT,
    value: value,
  };
}
